import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class MobianDateTimeField extends React.Component {
    state = {
        initialized: false,
        enteredDate: '',
        selectedHours: '',
        selectedMinutes: '',
    }

    componentDidMount() {
        const { value } = this.props.input;

        if (value) {
            this.handleInitializedState(value);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (utils.isEqual(prevState.initialized, this.state.initialized)) {
            if (!utils.isEqual(prevState, this.state)) {
                this.handleFetchData();
            }
        }

        if (!this.state.initialized) {
            this.handleInitializedState();
        }
    }

    /**
     * The initialized has been set to trigger this function one time.
     * In the future we want handle this better by sending the data on mount.
     */
    handleInitializedState = (value) => {
        value = value || this.props.input.value;

        // Set the initial state with the date
        let datetime = /([0-9]{4}-[0-9]{2}-[0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/.exec(value);

        this.setState({
            initialized: true,
            enteredDate: datetime[1],
            selectedHours: datetime[2],
            selectedMinutes: datetime[3],
        });
    }

    showValues = (type, maxAmount, steps = 1, value) => {
        const results = [];

        if (!utils.isUndefined(value)) {
            const lastCharacter = value.slice(1);

            if (lastCharacter !== '5' && lastCharacter !== '0') {
                results.push(<MenuItem value={ `${ value }` } key={ `${ type }-00` } primaryText={ `${ value }` } disabled={ true } />);
            }
        }

        for (let i = 0; i < maxAmount; i += steps) {
            let value = i < 10 ? `0${ i }` : i;

            results.push(<MenuItem value={ `${ value }` } key={ `${ type }-${ i }` } primaryText={ `${ value }` } />);
        }

        return results;
    }

    /**
     * This function updates the the date.
     */
    handleDateChange = (_, date) => {
        this.updateReduxState({
            enteredDate: date,
        });
    }

    /**
     * This function updates the the hours.
     */
    handleChangeHours = (e) => {

        // Trimming is needed because of allowed buttons e.g. "Enter"
        this.updateReduxState({
            selectedHours: e.target.innerText.trim(),
        });
    }

    /**
     * This function updates the the minutes.
     */
    handleChangeMinutes = (e) => {

        // Trimming is needed because of allowed buttons e.g. "Enter"
        this.updateReduxState({
            selectedMinutes: e.target.innerText.trim(),
        });
    }

    /**
     * Update the Redux state.
     */
    updateReduxState = (options) => {
        options = options || {};

        this.setState(options);

        const date = options.enteredDate || this.state.enteredDate;
        const hours = options.selectedHours || this.state.selectedHours;
        const minutes = options.selectedMinutes || this.state.selectedMinutes;

        this.props.input.onChange(`${ date } ${ hours }:${ minutes }:00`);
    }

    handleFetchData = () => {
        const date = this.state.enteredDate;
        const hours = this.state.selectedHours;
        const minutes = this.state.selectedMinutes;

        /**
         * If the date is not the correct format.
         * example: 2019-03-16
         */
        if (!/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(date)) {
            return;
        }

        this.props.input.onBlur(`${ date } ${ hours }:${ minutes }:00`);
    }

    render() {
        const { input, label, labelHours, labelMinutes, meta: { touched, error }, options, source, resource, disabled } = this.props;
        const { enteredDate, selectedHours, selectedMinutes } = this.state;

        return (
            <div style={ { display: 'flex' } }>
                <TextField
                    { ...input }
                    disabled={ disabled }
                    errorText={ touched && error }
                    floatingLabelText={ <FieldTitle label={ label } source={ source } resource={ resource } /> }
                    id={ `${ this.props.id }_date` }
                    onBlur={ this.handleFetchData }
                    onChange={ this.handleDateChange }
                    style={ {
                        width: '60%',
                        minWidth: '300px',
                    } }
                    value={ enteredDate }
                    { ...options }
                />

                <SelectField
                    disabled={ disabled }
                    errorText={ touched && error }
                    floatingLabelText={ <FieldTitle label={ labelHours } /> }
                    id={ `${ this.props.id }_hours` }
                    maxHeight={ 200 }
                    onChange={ this.handleChangeHours }
                    style={ {
                        width: '20%',
                        minWidth: '100px',
                    } }
                    value={ selectedHours }
                >
                    { this.showValues('hours', 24) }
                </SelectField>

                <SelectField
                    disabled={ disabled }
                    errorText={ touched && error }
                    floatingLabelText={ <FieldTitle label={ labelMinutes } /> }
                    id={ `${ this.props.id }_minutes` }
                    maxHeight={ 200 }
                    onChange={ this.handleChangeMinutes }
                    style={ {
                        width: '20%',
                        minWidth: '100px',
                    } }
                    value={ selectedMinutes }
                >
                    { this.showValues('minutes', 60, 5, selectedMinutes) }
                </SelectField>
            </div>
        );
    }
}

MobianDateTimeField.defaultProps = {
    options: {},
    disabled: false,
    labelHours: 'hours',
    labelMinutes: 'minutes',
};

MobianDateTimeField.propTypes = {
    disabled: PropTypes.bool.isRequired,
    elStyle: PropTypes.object,
    id: PropTypes.string,
    input: PropTypes.object,
    label: PropTypes.string,
    labelHours: PropTypes.string,
    labelMinutes: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
};

export default translate(MobianDateTimeField);



// WEBPACK FOOTER //
// ./src/components/input/MobianDateTimeField/MobianDateTimeField.js